import {
    ecsApi,
    GetQuestionsPayload,
    GetQuestionsResponse,
    GetTalksPayload,
    GetTalksResponse,
    GetThematicsResponse,
    PostResultsPayload
} from '@services';

export const talksApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getThematics: builder.mutation<GetThematicsResponse, undefined>({
            query: () => ({
                url: '/talks/thematics',
                method: 'GET'
            })
        }),
        getTalks: builder.mutation<GetTalksResponse, GetTalksPayload>({
            query: ({ thematicId }) => ({
                url: `/talks/${thematicId}`,
                method: 'GET'
            })
        }),
        getQuestions: builder.mutation<GetQuestionsResponse, GetQuestionsPayload>({
            query: ({ talkId }) => ({
                url: `/talks/${talkId}/questions`,
                method: 'GET'
            })
        }),
        postResults: builder.mutation<undefined, PostResultsPayload>({
            query: ({ talkId, ...payload }) => ({
                url: `/talks/${talkId}/answers`,
                method: 'POST',
                body: payload
            })
        })
    })
});

export const { useGetTalksMutation, useGetQuestionsMutation, useGetThematicsMutation, usePostResultsMutation } = talksApi;
